import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Anmelden from "./anmelden";

export default function InfoBlock({ element }) {
  return (
    <Container fluid>
      <Row>
        <Col className="layout_mb">
          <h2
            data-aos="fade-up"
            dangerouslySetInnerHTML={{ __html: element.title }}
          ></h2>
        </Col>
        <Col
          xs={12}
          sm={11}
          lg={8}
          xl={5}
          xxl={5}
          className="d-flex flex-column gap-new"
        >
          <p
            data-aos="fade-up"
            className="layout_text"
            dangerouslySetInnerHTML={{ __html: element.description }}
          ></p>
          {element.form && (
            <div data-aos="fade-up">
              <Anmelden btn="btn btn__fill btn__fill_primary" />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}
